import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { CampaignProvider } from './store/campaignStore'
import AppShell from '../templates/layout/AppShell'
import Landing from '../pages/Landing'
import MainMember from '../pages/mainMember'
import Activity from '../pages/Activity'
import ActivityMember from '../pages/ActivityMember'
import JourneyHub from '../pages/JourneyHub'
import ScanReceipt from '../pages/ScanReceipt'
import SubmitReceipt from '../pages/SubmitReceipt'
import Receipt from '../pages/receipt'
import MultiplyWealth from '../pages/MultiplyWealth'
import PartyJoin from '../pages/PartyMember'
import MeritBath from '../pages/MeritBath'
import Dashboard from '../pages/Dashboard'
import RedeemReward from '../pages/RedeemReward'
import Profile from '../pages/Profile'
import AdminMock from '../pages/AdminMock'
import MuteluLoading from '../templates/ui/muteluloading'
import { useLiffProfile } from '../../../context/LiffProfileContext'
import useMuteluLineProfile from '../hooks/useMuteluLineProfile'
import { logMuteluPageView } from '../utils/apiDebugLogger'
import bgImage from '../../../assets/images/game-mutelu/BG.jpg'
import ticketGoldImage from '../../../assets/images/game-mutelu/ticket-gold.png'
import ticketSilverImage from '../../../assets/images/game-mutelu/ticket-silver.png'
import ticketBronzeImage from '../../../assets/images/game-mutelu/ticket-broze.png'
import lineLogoImage from '../../../assets/images/game-mutelu/line-app-logo.png'
import '../templates/global.css'

export default function MuteluApp() {
  const location = useLocation()
  const { authToken, userId, profile } = useLiffProfile()
  const { ready: muteluLineReady } = useMuteluLineProfile()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    logMuteluPageView('MuteluApp', {
      routePath: location.pathname,
      routeSearch: location.search || ''
    })
  }, [location.pathname, location.search])

  useEffect(() => {
    const assetsToWarm = [
      bgImage,
      ticketGoldImage,
      ticketSilverImage,
      ticketBronzeImage,
      lineLogoImage,
      profile?.pictureUrl || localStorage.getItem('line_picture_url') || ''
    ].filter(Boolean)
    const preloaded = assetsToWarm.map((src) => {
      const img = new Image()
      img.decoding = 'async'
      img.src = src
      return img
    })
    return () => {
      preloaded.forEach((img) => {
        img.src = ''
      })
    }
  }, [profile?.pictureUrl])

  useEffect(() => {
    const storedUserId = String(userId || localStorage.getItem('userId') || '').trim()
    const storedAuthToken = String(authToken || localStorage.getItem('authToken') || '').trim()

    // mutelu ใช้ userId เป็นตัวหลักสำหรับ x-line-mid; authToken เป็น optional
    if (storedUserId) {
      setIsReady(true)
      return
    }

    if (muteluLineReady && !storedUserId) {
      setIsReady(false)
      return
    }

    setIsReady(Boolean(storedAuthToken && storedUserId))
  }, [authToken, muteluLineReady, userId])

  if (!isReady) {
    return (
      <div className="mutelu-shell min-h-screen">
        <main className="mx-auto flex min-h-screen w-full max-w-md items-center justify-center px-3 py-4">
          <MuteluLoading />
        </main>
      </div>
    )
  }

  return (
    <CampaignProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Activity />} />
          <Route path="mutelu-main" element={<Landing />} />
          <Route path="main-member" element={<MainMember />} />
          <Route path="activity" element={<Activity />} />
          <Route path="activity-member" element={<ActivityMember />} />
          <Route path="journey" element={<JourneyHub />} />
          <Route path="scan" element={<ScanReceipt />} />
          <Route path="receipt" element={<Receipt />} />
          <Route path="submit-receipt" element={<SubmitReceipt />} />
          <Route path="party" element={<MultiplyWealth />} />
          <Route path="party/:groupCode" element={<MultiplyWealth />} />
          <Route path="party-join" element={<PartyJoin />} />
          <Route path="party-join/:groupCode" element={<PartyJoin />} />
          <Route path="merit-bath" element={<MeritBath />} />
          <Route path="merit-bath/:roomId" element={<MeritBath />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="redeem-reward" element={<RedeemReward />} />
          <Route path="claim-reward" element={<RedeemReward />} />
          <Route path="profile" element={<Profile />} />
          <Route path="admin-mock" element={<AdminMock />} />
        </Route>
        <Route path="*" element={<Navigate to="/game/mutelu/activity" replace />} />
      </Routes>
    </CampaignProvider>
  )
}
